import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  CreateLinkedSpruceProjectMutation as _CreateLinkedSpruceProjectMutation,
  CreateLinkedSpruceProjectInput,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const CreateLinkedSpruceProjectMutationDocument = graphql(`
  mutation CreateLinkedSpruceProject($input: CreateLinkedSpruceProjectInput!) {
    createLinkedSpruceProject(input: $input) {
      __typename
      ... on CreateLinkedProjectError {
        code
        message
      }
    }
  }
`);

const useCreateLinkedSpruceProject = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    _CreateLinkedSpruceProjectMutation,
    unknown,
    CreateLinkedSpruceProjectInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateLinkedSpruceProjectInput) => {
      return gqlClient.request(CreateLinkedSpruceProjectMutationDocument, {
        input,
      });
    },
    onSuccess: (data) => {
      if (
        data.createLinkedSpruceProject.__typename ===
          'CreateLinkedProjectSuccess' &&
        args?.projectId
      ) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.integrations(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useCreateLinkedSpruceProject;
